/* LaiLai Noir — theme.js (no dependencies, deferred) */
(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Light scroll reveals (staggered) ---- */
  var revealEls = document.querySelectorAll('.reveal, .reveal-stagger');
  if (revealEls.length) {
    if (reducedMotion || !('IntersectionObserver' in window)) {
      revealEls.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      /* stagger siblings that reveal together (e.g. product grids) */
      var groupCounts = new Map();
      revealEls.forEach(function (el) {
        if (!el.classList.contains('reveal')) return;
        var p = el.parentElement;
        var i = groupCounts.get(p) || 0;
        el.style.setProperty('--reveal-i', i % 6);
        groupCounts.set(p, i + 1);
      });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      revealEls.forEach(function (el) { io.observe(el); });
    }
  }

  /* ---- Scroll-linked motion (hero parallax, dim-out, media drift) ---- */
  if (!reducedMotion) {
    var heroEl = document.querySelector('.hero');
    var heroMedia = document.querySelector('.hero .media-treat, .hero .hero-fallback');
    var heroDim = document.querySelector('.hero-dim');
    var driftImgs = Array.prototype.slice.call(
      document.querySelectorAll('.story-grid .media-treat img')
    );
    var showcasePanels = Array.prototype.slice.call(
      document.querySelectorAll('[data-showcase-panel]')
    );

    if (heroEl || driftImgs.length || showcasePanels.length) {
      var vh = window.innerHeight;
      var motionQueued = false;

      var applyMotion = function () {
        motionQueued = false;
        var y = window.scrollY;

        if (heroEl && heroMedia && y < heroEl.offsetHeight + vh) {
          /* image moves at 0.28x scroll speed; scale gives clipping headroom */
          heroMedia.style.transform =
            'translate3d(0,' + (y * 0.28).toFixed(1) + 'px,0) scale(1.12)';
          if (heroDim) {
            var p = Math.min(y / (heroEl.offsetHeight || 1), 1);
            heroDim.style.opacity = (p * 0.7).toFixed(3);
          }
        }

        /* card stack: as the next panel rises, scale + dim the one beneath */
        for (var i = 0; i < showcasePanels.length - 1; i++) {
          var next = showcasePanels[i + 1].getBoundingClientRect();
          if (next.top > vh || next.bottom < 0) {
            /* not transitioning: reset when fully uncovered */
            if (next.top > vh) {
              showcasePanels[i].style.transform = '';
              var d0 = showcasePanels[i].querySelector('.showcase-dim');
              if (d0) d0.style.opacity = '0';
            }
            continue;
          }
          var covered = Math.min(Math.max((vh - next.top) / vh, 0), 1);
          showcasePanels[i].style.transform = 'scale(' + (1 - covered * 0.07).toFixed(4) + ')';
          var dim = showcasePanels[i].querySelector('.showcase-dim');
          if (dim) dim.style.opacity = (covered * 0.55).toFixed(3);
        }

        driftImgs.forEach(function (img) {
          var r = img.parentElement.getBoundingClientRect();
          if (r.bottom < -60 || r.top > vh + 60) return;
          /* -0.5..0.5 as the block crosses the viewport centre */
          var t = (r.top + r.height / 2 - vh / 2) / vh;
          img.style.transform =
            'translate3d(0,' + (t * 30).toFixed(1) + 'px,0) scale(1.1)';
        });
      };

      var requestMotion = function () {
        if (motionQueued) return;
        motionQueued = true;
        window.requestAnimationFrame(applyMotion);
      };

      window.addEventListener('scroll', requestMotion, { passive: true });
      window.addEventListener('resize', function () {
        vh = window.innerHeight;
        requestMotion();
      }, { passive: true });
      applyMotion();
    }
  }

  /* ---- Header condenses on scroll ---- */
  var header = document.querySelector('.site-header');
  if (header && !reducedMotion) {
    var ticking = false;
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        header.classList.toggle('is-scrolled', window.scrollY > 24);
        ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- Product page: gallery thumbnail -> main image swap ---- */
  var galleryMain = document.querySelector('[data-gallery-main] img');
  var galleryThumbs = document.querySelectorAll('[data-gallery-thumb]');
  if (galleryMain && galleryThumbs.length) {
    galleryThumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        galleryMain.src = thumb.dataset.fullSrc;
        if (thumb.dataset.fullSrcset) galleryMain.srcset = thumb.dataset.fullSrcset;
        galleryThumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (window.matchMedia('(max-width: 860px)').matches) {
          galleryMain.closest('[data-gallery-main]').scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    });
  }

  /* ---- Product page: update price when variant changes ---- */
  var variantSelect = document.querySelector('[data-variant-select]');
  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      var opt = variantSelect.options[variantSelect.selectedIndex];
      var priceEl = document.querySelector('[data-price]');
      var compareEl = document.querySelector('[data-compare-price]');
      var addBtn = document.querySelector('[data-add-to-cart]');
      if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      if (compareEl) {
        if (opt.dataset.compare) {
          compareEl.textContent = opt.dataset.compare;
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (addBtn) {
        var available = opt.dataset.available === 'true';
        addBtn.disabled = !available;
        addBtn.textContent = available ? addBtn.dataset.labelAdd : addBtn.dataset.labelSoldout;
      }
    });
  }

  /* ---- Collection sorting ---- */
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---- Cart: submit form when a quantity changes ---- */
  var cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    cartForm.querySelectorAll('input[name="updates[]"]').forEach(function (input) {
      input.addEventListener('change', function () { cartForm.submit(); });
    });
  }

  /* ---- Close mobile menu when a link inside it is used ---- */
  var mobileMenu = document.querySelector('.mobile-menu');
  if (mobileMenu) {
    mobileMenu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () { mobileMenu.removeAttribute('open'); });
    });
    document.addEventListener('click', function (e) {
      if (mobileMenu.hasAttribute('open') && !mobileMenu.contains(e.target)) {
        mobileMenu.removeAttribute('open');
      }
    });
  }
})();
